import api from './api';

const BASE = '/hrm-payroll/api';

const hrmPayrollService = {
  // ── Wage Types ───────────────────────────────────────────────────────────────
  getWageTypes: (params = {}) => api.get(`${BASE}/wage-types/`, { params }),
  getWageType: (id) => api.get(`${BASE}/wage-types/${id}/`),
  createWageType: (data) => api.post(`${BASE}/wage-types/`, data),
  updateWageType: (id, data) => api.patch(`${BASE}/wage-types/${id}/`, data),
  deleteWageType: (id) => api.delete(`${BASE}/wage-types/${id}/`),

  // ── Compensation Plans ───────────────────────────────────────────────────────
  getCompensationPlans: (params = {}) => api.get(`${BASE}/compensation-plans/`, { params }),
  getCompensationPlan: (id) => api.get(`${BASE}/compensation-plans/${id}/`),
  createCompensationPlan: (data) => api.post(`${BASE}/compensation-plans/`, data),
  updateCompensationPlan: (id, data) => api.patch(`${BASE}/compensation-plans/${id}/`, data),
  deleteCompensationPlan: (id) => api.delete(`${BASE}/compensation-plans/${id}/`),

  // ── Employee Compensation ────────────────────────────────────────────────────
  getEmployeeCompensations: (params = {}) => api.get(`${BASE}/employee-compensations/`, { params }),
  getEmployeeCompensation: (id) => api.get(`${BASE}/employee-compensations/${id}/`),
  createEmployeeCompensation: (data) => api.post(`${BASE}/employee-compensations/`, data),
  updateEmployeeCompensation: (id, data) => api.patch(`${BASE}/employee-compensations/${id}/`, data),
  deleteEmployeeCompensation: (id) => api.delete(`${BASE}/employee-compensations/${id}/`),

  // ── Country Configuration ────────────────────────────────────────────────────
  getCountryConfigs: (params = {}) => api.get(`${BASE}/country-configs/`, { params }),
  getCountryConfig: (id) => api.get(`${BASE}/country-configs/${id}/`),
  createCountryConfig: (data) => api.post(`${BASE}/country-configs/`, data),
  updateCountryConfig: (id, data) => api.patch(`${BASE}/country-configs/${id}/`, data),
  deleteCountryConfig: (id) => api.delete(`${BASE}/country-configs/${id}/`),

  // ── Statutory Components ─────────────────────────────────────────────────────
  getStatutoryComponents: (params = {}) => api.get(`${BASE}/statutory-components/`, { params }),
  getStatutoryComponent: (id) => api.get(`${BASE}/statutory-components/${id}/`),
  createStatutoryComponent: (data) => api.post(`${BASE}/statutory-components/`, data),
  updateStatutoryComponent: (id, data) => api.patch(`${BASE}/statutory-components/${id}/`, data),
  deleteStatutoryComponent: (id) => api.delete(`${BASE}/statutory-components/${id}/`),

  // ── Tax Slabs ────────────────────────────────────────────────────────────────
  getTaxSlabs: (params = {}) => api.get(`${BASE}/tax-slabs/`, { params }),
  getTaxSlab: (id) => api.get(`${BASE}/tax-slabs/${id}/`),
  createTaxSlab: (data) => api.post(`${BASE}/tax-slabs/`, data),
  updateTaxSlab: (id, data) => api.patch(`${BASE}/tax-slabs/${id}/`, data),
  deleteTaxSlab: (id) => api.delete(`${BASE}/tax-slabs/${id}/`),

  // ── Payroll Areas ────────────────────────────────────────────────────────────
  getPayrollAreas: (params = {}) => api.get(`${BASE}/payroll-areas/`, { params }),
  getPayrollArea: (id) => api.get(`${BASE}/payroll-areas/${id}/`),
  createPayrollArea: (data) => api.post(`${BASE}/payroll-areas/`, data),
  updatePayrollArea: (id, data) => api.patch(`${BASE}/payroll-areas/${id}/`, data),
  deletePayrollArea: (id) => api.delete(`${BASE}/payroll-areas/${id}/`),

  // ── Payroll Periods ──────────────────────────────────────────────────────────
  getPayrollPeriods: (params = {}) => api.get(`${BASE}/payroll-periods/`, { params }),
  getPayrollPeriod: (id) => api.get(`${BASE}/payroll-periods/${id}/`),
  createPayrollPeriod: (data) => api.post(`${BASE}/payroll-periods/`, data),
  updatePayrollPeriod: (id, data) => api.patch(`${BASE}/payroll-periods/${id}/`, data),
  lockPayrollPeriod: (id) => api.post(`${BASE}/payroll-periods/${id}/lock/`),
  releasePayrollPeriod: (id) => api.post(`${BASE}/payroll-periods/${id}/release/`),
  closePayrollPeriod: (id) => api.post(`${BASE}/payroll-periods/${id}/close/`),

  // ── Area Assignments ─────────────────────────────────────────────────────────
  getAreaAssignments: (params = {}) => api.get(`${BASE}/area-assignments/`, { params }),
  createAreaAssignment: (data) => api.post(`${BASE}/area-assignments/`, data),
  updateAreaAssignment: (id, data) => api.patch(`${BASE}/area-assignments/${id}/`, data),
  deleteAreaAssignment: (id) => api.delete(`${BASE}/area-assignments/${id}/`),

  // ── Payroll Runs ─────────────────────────────────────────────────────────────
  getPayrollRuns: (params = {}) => api.get(`${BASE}/payroll-runs/`, { params }),
  getPayrollRun: (id) => api.get(`${BASE}/payroll-runs/${id}/`),
  createPayrollRun: (data) => api.post(`${BASE}/payroll-runs/`, data),
  updatePayrollRun: (id, data) => api.patch(`${BASE}/payroll-runs/${id}/`, data),
  executePayrollRun: (id) => api.post(`${BASE}/payroll-runs/${id}/execute/`),
  simulatePayrollRun: (id) => api.post(`${BASE}/payroll-runs/${id}/simulate/`),
  approvePayrollRun: (id) => api.post(`${BASE}/payroll-runs/${id}/approve/`),
  postPayrollRunToGL: (id) => api.post(`${BASE}/payroll-runs/${id}/post-to-gl/`),

  // ── Payroll Results ──────────────────────────────────────────────────────────
  getPayrollResults: (params = {}) => api.get(`${BASE}/payroll-results/`, { params }),
  getPayrollResult: (id) => api.get(`${BASE}/payroll-results/${id}/`),
  createPayrollResult: (data) => api.post(`${BASE}/payroll-results/`, data),
  updatePayrollResult: (id, data) => api.patch(`${BASE}/payroll-results/${id}/`, data),

  // ── Payroll Result Lines ─────────────────────────────────────────────────────
  getPayrollResultLines: (params = {}) => api.get(`${BASE}/payroll-result-lines/`, { params }),

  // ── Employee Tax Config ──────────────────────────────────────────────────────
  getEmployeeTaxConfigs: (params = {}) => api.get(`${BASE}/employee-tax-configs/`, { params }),
  getEmployeeTaxConfig: (id) => api.get(`${BASE}/employee-tax-configs/${id}/`),
  createEmployeeTaxConfig: (data) => api.post(`${BASE}/employee-tax-configs/`, data),
  updateEmployeeTaxConfig: (id, data) => api.patch(`${BASE}/employee-tax-configs/${id}/`, data),
  deleteEmployeeTaxConfig: (id) => api.delete(`${BASE}/employee-tax-configs/${id}/`),

  // ── Tax Declarations ─────────────────────────────────────────────────────────
  getTaxDeclarations: (params = {}) => api.get(`${BASE}/tax-declarations/`, { params }),
  getTaxDeclaration: (id) => api.get(`${BASE}/tax-declarations/${id}/`),
  createTaxDeclaration: (data) => api.post(`${BASE}/tax-declarations/`, data),
  updateTaxDeclaration: (id, data) => api.patch(`${BASE}/tax-declarations/${id}/`, data),
  verifyTaxDeclaration: (id) => api.post(`${BASE}/tax-declarations/${id}/verify/`),

  // ── Tax Projections ──────────────────────────────────────────────────────────
  getTaxProjections: (params = {}) => api.get(`${BASE}/tax-projections/`, { params }),
  getTaxProjection: (id) => api.get(`${BASE}/tax-projections/${id}/`),
  createTaxProjection: (data) => api.post(`${BASE}/tax-projections/`, data),
  updateTaxProjection: (id, data) => api.patch(`${BASE}/tax-projections/${id}/`, data),
  deleteTaxProjection: (id) => api.delete(`${BASE}/tax-projections/${id}/`),

  // ── Recurring Payments ───────────────────────────────────────────────────────
  getRecurringPayments: (params = {}) => api.get(`${BASE}/recurring-payments/`, { params }),
  createRecurringPayment: (data) => api.post(`${BASE}/recurring-payments/`, data),
  updateRecurringPayment: (id, data) => api.patch(`${BASE}/recurring-payments/${id}/`, data),
  deleteRecurringPayment: (id) => api.delete(`${BASE}/recurring-payments/${id}/`),

  // ── Additional Payments ──────────────────────────────────────────────────────
  getAdditionalPayments: (params = {}) => api.get(`${BASE}/additional-payments/`, { params }),
  createAdditionalPayment: (data) => api.post(`${BASE}/additional-payments/`, data),
  updateAdditionalPayment: (id, data) => api.patch(`${BASE}/additional-payments/${id}/`, data),
  deleteAdditionalPayment: (id) => api.delete(`${BASE}/additional-payments/${id}/`),

  // ── GL Configuration ─────────────────────────────────────────────────────────
  getPayrollGLConfigs: (params = {}) => api.get(`${BASE}/payroll-gl-configs/`, { params }),
  createPayrollGLConfig: (data) => api.post(`${BASE}/payroll-gl-configs/`, data),
  updatePayrollGLConfig: (id, data) => api.patch(`${BASE}/payroll-gl-configs/${id}/`, data),
  deletePayrollGLConfig: (id) => api.delete(`${BASE}/payroll-gl-configs/${id}/`),

  // ── Compensation Zones ───────────────────────────────────────────────────────
  getCompensationZones: (params = {}) => api.get(`${BASE}/compensation-zones/`, { params }),
  createCompensationZone: (data) => api.post(`${BASE}/compensation-zones/`, data),
  updateCompensationZone: (id, data) => api.patch(`${BASE}/compensation-zones/${id}/`, data),
  deleteCompensationZone: (id) => api.delete(`${BASE}/compensation-zones/${id}/`),

  // ── Compensation Bands ───────────────────────────────────────────────────────
  getCompensationBands: (params = {}) => api.get(`${BASE}/compensation-bands/`, { params }),
  createCompensationBand: (data) => api.post(`${BASE}/compensation-bands/`, data),
  updateCompensationBand: (id, data) => api.patch(`${BASE}/compensation-bands/${id}/`, data),
  deleteCompensationBand: (id) => api.delete(`${BASE}/compensation-bands/${id}/`),

  // ── Compensation Steps ───────────────────────────────────────────────────────
  getCompensationSteps: (params = {}) => api.get(`${BASE}/compensation-steps/`, { params }),
  createCompensationStep: (data) => api.post(`${BASE}/compensation-steps/`, data),
  updateCompensationStep: (id, data) => api.patch(`${BASE}/compensation-steps/${id}/`, data),
  deleteCompensationStep: (id) => api.delete(`${BASE}/compensation-steps/${id}/`),

  // ── Compensation Grid ────────────────────────────────────────────────────────
  getCompensationGrid: (params = {}) => api.get(`${BASE}/compensation-grid/`, { params }),
  createCompensationGridEntry: (data) => api.post(`${BASE}/compensation-grid/`, data),
  updateCompensationGridEntry: (id, data) => api.patch(`${BASE}/compensation-grid/${id}/`, data),
  deleteCompensationGridEntry: (id) => api.delete(`${BASE}/compensation-grid/${id}/`),

  // ── Employee Compensation Components ─────────────────────────────────────────
  getEmployeeCompensationComponents: (params = {}) => api.get(`${BASE}/employee-compensation-components/`, { params }),
  createEmployeeCompensationComponent: (data) => api.post(`${BASE}/employee-compensation-components/`, data),
  updateEmployeeCompensationComponent: (id, data) => api.patch(`${BASE}/employee-compensation-components/${id}/`, data),
  deleteEmployeeCompensationComponent: (id) => api.delete(`${BASE}/employee-compensation-components/${id}/`),

  // ── Tenant Statutory Overrides ───────────────────────────────────────────────
  getTenantOverrides: (params = {}) => api.get(`${BASE}/tenant-overrides/`, { params }),
  createTenantOverride: (data) => api.post(`${BASE}/tenant-overrides/`, data),
  updateTenantOverride: (id, data) => api.patch(`${BASE}/tenant-overrides/${id}/`, data),
  deleteTenantOverride: (id) => api.delete(`${BASE}/tenant-overrides/${id}/`),

  // ── Off-Cycle Payroll ────────────────────────────────────────────────────────
  getOffCyclePayrolls: (params = {}) => api.get(`${BASE}/off-cycle-payrolls/`, { params }),
  getOffCyclePayroll: (id) => api.get(`${BASE}/off-cycle-payrolls/${id}/`),
  createOffCyclePayroll: (data) => api.post(`${BASE}/off-cycle-payrolls/`, data),
  updateOffCyclePayroll: (id, data) => api.patch(`${BASE}/off-cycle-payrolls/${id}/`, data),
  deleteOffCyclePayroll: (id) => api.delete(`${BASE}/off-cycle-payrolls/${id}/`),
  approveOffCyclePayroll: (id) => api.post(`${BASE}/off-cycle-payrolls/${id}/approve/`),
  // The off-cycle lifecycle (engine/off_cycle_engine.py): the calculation
  // writes an OFF_CYCLE payroll run; approval, GL posting and the bank file
  // are that run's own. The status is engine-owned — never PATCHed.
  calculateOffCyclePayroll: (id) => api.post(`${BASE}/off-cycle-payrolls/${id}/calculate/`),
  postOffCyclePayroll: (id) => api.post(`${BASE}/off-cycle-payrolls/${id}/post-to-gl/`),
  reverseOffCyclePayroll: (id, remark) => api.post(`${BASE}/off-cycle-payrolls/${id}/reverse/`, { remark }),
  offCycleBankFile: (id, bankFileConfig, splitByBank) => api.post(`${BASE}/off-cycle-payrolls/${id}/bank-file/`, { bank_file_config: bankFileConfig, split_by_bank: splitByBank }),
  getOffCyclePayments: (id) => api.get(`${BASE}/off-cycle-payrolls/${id}/payments/`),

  // ── Off-Cycle Items ──────────────────────────────────────────────────────────
  getOffCycleItems: (params = {}) => api.get(`${BASE}/off-cycle-items/`, { params }),
  createOffCycleItem: (data) => api.post(`${BASE}/off-cycle-items/`, data),
  updateOffCycleItem: (id, data) => api.patch(`${BASE}/off-cycle-items/${id}/`, data),
  deleteOffCycleItem: (id) => api.delete(`${BASE}/off-cycle-items/${id}/`),

  // ── Final Settlements ────────────────────────────────────────────────────────
  getFinalSettlements: (params = {}) => api.get(`${BASE}/final-settlements/`, { params }),
  getFinalSettlement: (id) => api.get(`${BASE}/final-settlements/${id}/`),
  createFinalSettlement: (data) => api.post(`${BASE}/final-settlements/`, data),
  updateFinalSettlement: (id, data) => api.patch(`${BASE}/final-settlements/${id}/`, data),
  deleteFinalSettlement: (id) => api.delete(`${BASE}/final-settlements/${id}/`),

  // ── Retro Calculations ───────────────────────────────────────────────────────
  getRetroCalculations: (params = {}) => api.get(`${BASE}/retro-calculations/`, { params }),
  createRetroCalculation: (data) => api.post(`${BASE}/retro-calculations/`, data),
  updateRetroCalculation: (id, data) => api.patch(`${BASE}/retro-calculations/${id}/`, data),
  deleteRetroCalculation: (id) => api.delete(`${BASE}/retro-calculations/${id}/`),

  // ── Payroll Posting Logs ─────────────────────────────────────────────────────
  getPayrollPostingLogs: (params = {}) => api.get(`${BASE}/payroll-posting-logs/`, { params }),

  // ── Payslip Templates ────────────────────────────────────────────────────────
  getPayslipTemplates: (params = {}) => api.get(`${BASE}/payslip-templates/`, { params }),
  createPayslipTemplate: (data) => api.post(`${BASE}/payslip-templates/`, data),
  updatePayslipTemplate: (id, data) => api.patch(`${BASE}/payslip-templates/${id}/`, data),
  deletePayslipTemplate: (id) => api.delete(`${BASE}/payslip-templates/${id}/`),
  getPayslipShippedLayout: () => api.get(`${BASE}/payslip-templates/shipped-layout/`),
  getPayslipVariables: () => api.get(`${BASE}/payslip-templates/variables/`),
  // Preview renders on the server (WeasyPrint) - the PDF is what employees receive.
  previewPayslipTemplate: (data) =>
    api.post(`${BASE}/payslip-templates/preview/`, data, { responseType: 'blob' }),

  // ── Payslips of a run (HR) ───────────────────────────────────────────────────
  getRunPayslips: (runId, params = {}) => api.get(`${BASE}/payroll-runs/${runId}/payslips/`, { params }),
  printRunPayslips: (runId, body = {}) =>
    api.post(`${BASE}/payroll-runs/${runId}/payslips/print/`, body, { responseType: 'blob' }),
  emailRunPayslips: (runId, body = {}) => api.post(`${BASE}/payroll-runs/${runId}/payslips/email/`, body),
  getResultPayslipPdf: (resultId) =>
    api.get(`${BASE}/payroll-results/${resultId}/payslip/`, { params: { as: 'pdf', inline: 1 }, responseType: 'blob' }),

  // ── Bank File Configs ────────────────────────────────────────────────────────
  getBankFileConfigs: (params = {}) => api.get(`${BASE}/bank-file-configs/`, { params }),
  createBankFileConfig: (data) => api.post(`${BASE}/bank-file-configs/`, data),
  updateBankFileConfig: (id, data) => api.patch(`${BASE}/bank-file-configs/${id}/`, data),
  deleteBankFileConfig: (id) => api.delete(`${BASE}/bank-file-configs/${id}/`),

  // ── Bank File Generations ────────────────────────────────────────────────────
  getBankFileGenerations: (params = {}) => api.get(`${BASE}/bank-file-generations/`, { params }),
  createBankFileGeneration: (data) => api.post(`${BASE}/bank-file-generations/`, data),
  updateBankFileGeneration: (id, data) => api.patch(`${BASE}/bank-file-generations/${id}/`, data),
  deleteBankFileGeneration: (id) => api.delete(`${BASE}/bank-file-generations/${id}/`),
};

export default hrmPayrollService;
